import React from 'react';
import { operationSteps } from '../mock';

export default function Workflow() {
  return (
    <section id="workflow" className="relative bg-[#F2EFE6]">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
              How it operates in practice
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02] text-[#0B1F2D]">
              A workflow your
              <br />
              <span className="italic">teams can ship.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#0B1F2D]/70 max-w-[640px]">
              ESGine® evaluates your ESG disclosures against specific regulatory rules and returns clause-traceable
              results your teams can act on immediately, before findings reach regulators, exchanges, or assurance
              providers.
            </p>
          </div>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-[58px] left-[8%] right-[8%] h-px bg-[#0B1F2D]/15" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {operationSteps.map((s, i) => (
              <div key={s.title} className="relative card-lift rounded-2xl border border-[#E8E5DC] bg-[#FAFAF5] p-7">
                <div className="flex items-center justify-between">
                  <span className="font-mono-tight text-[11px] tracking-[0.12em] uppercase text-[#0B1F2D]/55">
                    {s.step}
                  </span>
                  <span className="w-2.5 h-2.5 rounded-full bg-[#1B6F5E]" />
                </div>
                <div className="mt-7 font-display text-[22px] leading-[1.15] text-[#0B1F2D]">{s.title}</div>
                <p className="mt-3 text-[13.5px] leading-[1.6] text-[#0B1F2D]/65">{s.desc}</p>
                <div className="mt-7 pt-5 border-t border-[#E8E5DC] flex items-center justify-between text-[11.5px] text-[#0B1F2D]/55">
                  <span>{['Inputs', 'Extraction', 'Evaluation', 'Output'][i]}</span>
                  <span className="font-mono-tight">0{i + 1}/04</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
